import axiosHelper from "../axiosHelper";
import EmployeeScheduledDateModel from "@/models/EmployeeScheduledDateModel";

export default class EmployeesSchedulesApiClient {
	url: string = '/api/employeeschedules';
	jwt: string;

	constructor(jwt: string) {
		this.jwt = jwt;
	}

	async getScheduleAsync(year: number, employeeId: number) : Promise<Array<EmployeeScheduledDateModel> | null>  {
		try {			
			const getScheduleHttpClient = axiosHelper.createInstance(this.jwt);
			const response = await getScheduleHttpClient.get(`/api/employeeschedules/${employeeId}`, { params: { year } });
			if (!response.data?.length) {				
				return [];
			}

			return response.data.map((_: any) => new EmployeeScheduledDateModel(_));
		}
		catch(e: any) {			
			console.error(`Unable to load employee's #${employeeId} schedule`, e);
			return null;
		}
	}

	async deleteScheduleAsync(scheduledDateId: number) {
		try {
			const deleteScheduleHttpClient = axiosHelper.createInstance(this.jwt);
			await deleteScheduleHttpClient.delete(`${this.url}/${scheduledDateId}`);
			return true;
		} catch(e: any) {
			//conflict
			if (e.status === 409) {
				return false;
			}
			console.error(`Unable to delete employee's #${scheduledDateId} schedule`, e);
			return false;
		}
	}

	async addScheduleAsync(scheduledDate: EmployeeScheduledDateModel) {
		const request = {
			employeeId: scheduledDate.employee!.id,
			scheduledDate: this.convertDateToDateOnly(scheduledDate.scheduledDate),
			scheduledStartTime: scheduledDate.scheduledStartTime,
			scheduledEndTime: scheduledDate.scheduledEndTime
		};
		try {
			const getScheduleHttpClient = axiosHelper.createInstance(this.jwt);
			const response = await getScheduleHttpClient.post(this.url, request);
			return response?.data > 0;
		} catch(e: any) {
			//conflict
			if (e.status === 409) {
				return false;
			}
			//bad request
			if (e.status === 400) {
				return false;
			}
			console.error(`Unable to add employee's #${scheduledDate!.employee!.id} schedule`, e, request);
			return false;
		}
	}

	async updateScheduleAsync(scheduledDate: EmployeeScheduledDateModel) {
		const request = {
			id: scheduledDate.id,
			employeeId: scheduledDate.employee!.id,
			scheduledDate: this.convertDateToDateOnly(scheduledDate.scheduledDate),
			scheduledStartTime: scheduledDate.scheduledStartTime,
			scheduledEndTime: scheduledDate.scheduledStartTime
		};
		try {
			const getScheduleHttpClient = axiosHelper.createInstance(this.jwt);
			await getScheduleHttpClient.put('/api/employeeschedules', request);
			return true;
		} catch(e: any) {
			//conflict
			if (e.status === 409) {
				return false
			}

			if (e.status === 400) {
				return false
			}

			console.error(`Unable to update employee's #${scheduledDate!.employee!.id} schedule`, e, request);
			return false;
		}
	}

	convertDateToDateOnly(date: Date) : string {
		const y = date.getFullYear();
		const m = date.getMonth() + 1;
		const d = date.getDate();

		const month = m < 10 ? `0${m}` : m + '';
		const day = d < 10 ? `0${d}` : d + '';

		return `${y}-${month}-${day}`;
	}
}